// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.featurelaunch.RentalManagerUserFeatureLaunchWebApiHandler

import type { UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import {
  RentalManagerUserFeatureLaunchWebApiHandler_notifications,
  RentalManagerUserFeatureLaunchWebApiHandler_notifications_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type { FeatureLaunchNotificationsResponseWebDto } from '@zg-rentals/ts-rental-manager-api-client';

interface NotificationsParams {
  bypassAcknowledged?: boolean;
}

export type RentalManagerUserFeatureLaunchWebApiHandler_notifications_Options = UseQueryOptions<
  FeatureLaunchNotificationsResponseWebDto,
  unknown,
  FeatureLaunchNotificationsResponseWebDto,
  Array<string | NotificationsParams>
>;

const RentalManagerUserFeatureLaunchWebApiHandler_notifications_GetKey = (getParams: NotificationsParams) => [
  RentalManagerUserFeatureLaunchWebApiHandler_notifications_Path,
  getParams,
];

/**
 * Get list of feature launch notifications for a user
 */
export const useRentalManagerUserFeatureLaunchWebApiHandler_notifications = (
  getParams: NotificationsParams,
  options: Omit<RentalManagerUserFeatureLaunchWebApiHandler_notifications_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentalManagerUserFeatureLaunchWebApiHandler_notifications_GetKey(getParams),
    queryFn: () => RentalManagerUserFeatureLaunchWebApiHandler_notifications(getParams),
  });
};
useRentalManagerUserFeatureLaunchWebApiHandler_notifications.getKey =
  RentalManagerUserFeatureLaunchWebApiHandler_notifications_GetKey;
